export const PAYMENT_METHODS = ['cash', 'paymentCard', 'bankTransfer', 'other'] as const;

export type PaymentRequired = boolean;
export type PaymentEnabled = boolean;
export type PaymentAmount = number;
export type PaymentMethod = typeof PAYMENT_METHODS[number];
export type PaymentMethodDescription = string;
export type PaymentAcceptedCorrectly = boolean;

export type PaymentFormBean = {
   required: PaymentRequired;
   enabled: PaymentEnabled;
   amount: PaymentAmount | null;
   method: PaymentMethod;
   methodDescription?: PaymentMethodDescription | null;
   acceptedCorrectly?: PaymentAcceptedCorrectly;
};

export type PaymentFormBeanPart = {
   payment: PaymentFormBean;
};
